import React from 'react';
import Row from 'react-bootstrap/Row';

function ResendLink (props) {
    return(
        <Row className = "justify-content-center">
            <div>
            <p className = "linkTitle linkPadding">{props.lineText}&nbsp;
                <a className = {props.className} href={props.linkAddress}>{props.linkText}</a> 
            </p>
            </div>
        </Row>
        )
}

export default ResendLink;